import { useQuery } from 'react-query'
import { useApi } from '../components/ApiContext'

export const useProjects = () => {
  const api = useApi()
  return useQuery('api.getProjects', api.getProjects)
}
